import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { IFilterState, ProductPriceType } from 'src/areas/product/types';
import { IPricelistFilterConfig } from '../../types';
import { FilterEnum, FilterType } from '../types';

export const getProductTypeFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
): IPricelistFilterConfig[] => {
  return getAllFilters(t, filters, hiddenListOptions).filter(
    f => f.type === FilterType.PRODUCT_PRICE_TYPE
  );
};

export const getPricelistSettingFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
): IPricelistFilterConfig[] => {
  return getAllFilters(t, filters, hiddenListOptions).filter(
    f => f.type === FilterType.PRICE_LIST_SETTING
  );
};

export const getAllFilters = (
  t: TranslateFunc,
  filters: IFilterState,
  hiddenListOptions: string[]
): IPricelistFilterConfig[] => {
  return [
    {
      name: FilterEnum.PRICES_INC_SHIPPING,
      type: FilterType.PRICE_LIST_SETTING,
      checked: filters.showPricesInclShipping,
      label: t('product', 'price-filter.price-includes-shipping'),
      caption: t('product', 'price-filter.price-includes-shipping-caption'),
      hide: false,
    },
    {
      name: FilterEnum.PICKUP_ONLY,
      type: FilterType.PRODUCT_PRICE_TYPE,
      checked: filters.showPickupOnly,
      label: t('product', 'price-filter.pickup-only'),
      caption: t('product', 'price-filter.pickup-only-caption'),
      hide: Boolean(
        hiddenListOptions.filter(
          option => option === ProductPriceType.PICKUP_ONLY
        ).length
      ),
    },
    {
      name: FilterEnum.INTERNATIONAL,
      type: FilterType.PRODUCT_PRICE_TYPE,
      checked: filters.showInternational,
      label: t('product', 'price-filter.international'),
      caption: t('product', 'price-filter.international-caption'),
      hide: Boolean(
        hiddenListOptions.filter(
          option => option === ProductPriceType.INTERNATIONAL
        ).length
      ),
    },
    {
      name: FilterEnum.UNAVAILABLE,
      type: FilterType.PRODUCT_PRICE_TYPE,
      checked: filters.showUnavailable,
      label: t('product', 'price-filter.not-available-for-purchase'),
      caption: t('product', 'price-filter.not-available-for-purchase-caption'),
      hide: false,
    },
  ];
};
